module.exports = __webpack_public_path__ + "static/physical-mental-health-body-2-e687079af40f42cd3734c5c52c68cc50.jpg";